import ClientModule from "@gqlapp/module-client-react";
import qrcode from "./qrcode";
import bgSettings from "./bgSettings";
export default new ClientModule({
	popupComponents: [
		{ component: qrcode },
		{ component: bgSettings }
	]
});
